import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Bell } from 'lucide-react';
import { tasksApi } from '../../services/api';
import { useAuth } from '../../contexts/AuthContext';
import { timeAgo } from './taskUtils';
import '../WhatsNewBell.css';
import './TaskBell.css';

const POLL_MS = 60000;

/**
 * Колокольчик задач в шапке (у рабочих нет Telegram): новые задачи, поручения, проблемы, проверка.
 * Опрос раз в минуту; нажатие — список, клик по строке — карточка задачи и «прочитано».
 */
export default function TaskBell({ variant = 'sidebar' }) {
  const navigate = useNavigate();
  const auth = useAuth();
  const [data, setData] = useState({ unread: 0, items: [] });
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const allowed = !!auth.user && (auth.user.company_id || auth.hasPermission?.('tasks'));

  const load = useCallback(() => {
    if (!allowed) return;
    tasksApi.notifications().then((r) => setData(r.data)).catch(() => {});
  }, [allowed]);
  useEffect(() => { load(); const t = setInterval(load, POLL_MS); return () => clearInterval(t); }, [load]);
  useEffect(() => {
    if (!open) return undefined;
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, [open]);

  if (!allowed) return null;
  const go = async (n) => {
    setOpen(false);
    if (!n.read) { try { await tasksApi.readNotifications([n.id]); } catch { /* не критично */ } }
    load();
    if (n.link) navigate(n.link);
  };
  const readAll = async () => { try { await tasksApi.readNotifications(null); } catch { /* не критично */ } load(); };

  return (
    <div className="tkb" ref={ref}>
      <button type="button" className={`wn-bell wn-bell--${variant} tkb__btn`} onClick={() => setOpen((o) => !o)}
              title={data.unread ? `Задачи: непрочитанных ${data.unread}` : 'Уведомления по задачам'} aria-label="Уведомления по задачам">
        <Bell size={17} />
        {data.unread > 0 && <span className="wn-bell__count">{data.unread > 9 ? '9+' : data.unread}</span>}
      </button>
      {open && (
        <div className={`tkb__pop tkb__pop--${variant}`}>
          <div className="tkb__head">
            <b>Задачи</b>
            {data.unread > 0 && <button type="button" className="tk-link" onClick={readAll}>прочитать всё</button>}
          </div>
          {data.items.length === 0 && <div className="tkb__empty">Пока тихо</div>}
          {data.items.map((n) => (
            <button key={n.id} type="button" className={`tkb__item ${n.read ? '' : 'is-unread'}`} onClick={() => go(n)}>
              <div className="tkb__title">{n.title}</div>
              {n.body && <div className="tkb__body">{n.body}</div>}
              <div className="tkb__time">{timeAgo(n.created_at)}</div>
            </button>
          ))}
          <button type="button" className="tkb__all" onClick={() => { setOpen(false); navigate('/tasks'); }}>Открыть задачи</button>
        </div>
      )}
    </div>
  );
}
